import { render, staticRenderFns } from "./BidDefaultLayout.vue?vue&type=template&id=772f7384&scoped=true"
import script from "./BidDefaultLayout.vue?vue&type=script&lang=js"
export * from "./BidDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f7384",
  null
  
)

export default component.exports